import React, { forwardRef } from 'react';
import { formatAnswersHumanLines } from '../lib/diagnosticAnswerLabels';
import './DiagnosticPdfSheet.css';

function fmt(n) {
  return n.toLocaleString('en-CA');
}

const DiagnosticPdfSheet = forwardRef(function DiagnosticPdfSheet(
  { report, answers, firstName, lastName, email },
  ref
) {
  if (!report) return null;
  const answerLines = formatAnswersHumanLines(answers || {});

  return (
    <div ref={ref} className="diag-pdf-sheet">
      <header className="diag-pdf-sheet__head">
        <p className="diag-pdf-sheet__brand">Cure8 Studios</p>
        <h1 className="diag-pdf-sheet__title">Lead leak diagnostic summary</h1>
        <p className="diag-pdf-sheet__meta">
          {firstName} {lastName} · {email}
          <br />
          {new Date().toLocaleString()}
        </p>
      </header>

      <section className="diag-pdf-sheet__metrics">
        <div>
          <span className="diag-pdf-sheet__label">Estimated monthly leakage</span>
          <strong className="diag-pdf-sheet__num">${fmt(report.monthlyLeakage)}/mo</strong>
          <span className="diag-pdf-sheet__sub">${fmt(report.annualLeakage)} / year</span>
          {report.teamLabel && <span className="diag-pdf-sheet__sub">~{report.teamLabel}</span>}
        </div>
        <div>
          <span className="diag-pdf-sheet__label">Recoverable (estimate)</span>
          <strong className="diag-pdf-sheet__num diag-pdf-sheet__num--green">~${fmt(report.recoverable)}/mo</strong>
        </div>
      </section>

      <section className="diag-pdf-sheet__section">
        <h2 className="diag-pdf-sheet__h2">Where it is coming from</h2>
        {(report.gaps || []).map((gap, i) => (
          <div key={i} className="diag-pdf-sheet__gap">
            <div className="diag-pdf-sheet__gap-line">
              <span>{gap.title}</span>
              <span className="diag-pdf-sheet__gap-cost">${fmt(gap.cost)}/mo</span>
            </div>
            <p className="diag-pdf-sheet__gap-fix">{gap.fix}</p>
          </div>
        ))}
      </section>

      <section className="diag-pdf-sheet__rec">
        <span className="diag-pdf-sheet__label">Recommended starting point</span>
        <p className="diag-pdf-sheet__rec-name">{report.recommended === 'pro' ? 'The Pro' : 'The Pilot'}</p>
      </section>

      {answerLines.length > 0 && (
        <section className="diag-pdf-sheet__section">
          <h2 className="diag-pdf-sheet__h2">Your answers</h2>
          <ul className="diag-pdf-sheet__answers">
            {answerLines.map((line, i) => (
              <li key={i}>{line.replace(/^-\s*/, '')}</li>
            ))}
          </ul>
        </section>
      )}
    </div>
  );
});

export default DiagnosticPdfSheet;
